// extracted by mini-css-extract-plugin
export default {"predefinedQuestionsContainer":"HelpAndSupportModal_predefinedQuestionsContainer__pNQyM","predefinedQuestionButton":"HelpAndSupportModal_predefinedQuestionButton__osgre"};